// src/features/auth/constants.js
export const AUTH_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
export const AUTH_HEADER = 'Authorization';
export const AUTH_SCHEME = 'Bearer';
export const AUTH_PATHS = {
  LOGIN: 'login',
  VALIDATE: 'validate',
  USER: 'me',
  REFRESH: 'refresh',
  LOGOUT: 'logout'
}; 